import { Box } from "@mui/material";
import ModalBox from ".";
import AmbassadorProfile from "../../screens/my-profile/ambassador-profile";

export default function ProfileViewModal({
  id,
  customComponent,
  onClose,
  showCompanyName,
  showIntrestedIn = false,
  modalSize="md"
}: any) {
  if (customComponent) {
    return (
      <ModalBox
        onClose={onClose}
        showFooter={false}
        maxWidth={modalSize}
        disableGradient
      >
        {customComponent}
      </ModalBox>
    );
  }

  return (
    <ModalBox
      title={"Profile"}
      onClose={onClose}
      showFooter={false}
      maxWidth={modalSize}
    >
      <Box mt={2}>
        <AmbassadorProfile
          id={id}
          editable={false}
          showCompanyName={showCompanyName}
          showIntrestedIn={showIntrestedIn}
        />
      </Box>
    </ModalBox>
  );
}
